var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileBottom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 21.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #1d2c3c;\n      }\n\n      .cls-2 {\n        fill-rule: evenodd;\n        stroke: #283c51;\n        stroke-miterlimit: 10;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 18.01,
    width: 100,
    height: 3.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m100,18.5c-10.11,0-19.16-5.57-27.87-10.93-.9-.55-1.79-1.1-2.69-1.65-5.67-3.44-12.32-5.43-19.44-5.43s-13.77,1.98-19.44,5.43c-.89.54-1.79,1.09-2.69,1.65C19.17,12.93,10.11,18.5,0,18.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileBottom);
export default __webpack_public_path__ + "static/media/mobile-bottom.04211570e56dfac4b38363b226631937.svg";
export { ForwardRef as ReactComponent };